// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qNmn","colBig":"styles_colBig__1hb4Z","colSmall":"styles_colSmall__xI1wA"};